import React from 'react'
import { Phone, Mail, Ship, Globe, Headphones, CreditCard, Layers } from 'lucide-react';


export default function Sidebar() {

   const benefits = [
    {
      title: "Range of Options",
      desc: "Widest Range of Boats and Services Pan India.",
      icon: <Ship size={20} />
    },
    {
      title: "Online Booking",
      desc: "Search, Compare and Book Online.",
      icon: <Globe size={20} />
    },
    {
      title: "Excellent Support",
      desc: "Customer care from booking to completion.",
      icon: <Headphones size={20} />
    },
    {
      title: "Rate Transparency",
      desc: "Best Deals and Rates Online.",
      icon: <CreditCard size={20} />
    },
    {
      title: "End to End Solutions",
      desc: "Booking of Yachts, Meals, Décor, Music, all can be managed.",
      icon: <Layers size={20} />
    }
  ];

  return (
    <>
    <div className="attractive-customer-sidebar">
          <h4 className="attractive-sidebar-heading">Customer Care</h4>

          <p className="attractive-sidebar-note">
            Need assistance or have a special request?
          </p>

          <div className="attractive-contact-detail">
            <span>  <Phone size={18} /> Call/WhatsApp:</span>
            <span>+91 7977600563</span>
            <span>+91 9004013301</span>
          </div>

          <div className="attractive-contact-detail">
            <span> <Mail size={18} /> Email:</span>
            <span>customercare@indiaboats.in</span>
          </div>

          <p className="attractive-sidebar-note">
            We are available 24/7 to help you.
          </p>
        </div>
    {/* <div className="vlt-sb-benefits-card">
      <h3 className="vlt-sb-title">Why Book with us?</h3>
      
      <div className="vlt-sb-list">
        {benefits.map((item, index) => (
          <div key={index} className="vlt-sb-item">
            <div className="vlt-sb-icon-box">
              {item.icon}
            </div>
            <div className="vlt-sb-content">
              <h4 className="vlt-sb-item-title">{item.title}</h4>
              <p className="vlt-sb-item-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
      </div> */}
     
    </>
      
   
  )
}